import styled, { css } from 'styled-components';
import { Color, MaxWidth } from '../../base';

const WellWrapper = styled.div`
  overflow-wrap: break-word;
  border: 2px solid ${Color.grey};
  border-radius: 5px;
  &:last-child {
    margin-bottom: 0;
  }

  ${props =>
    props.small
      ? css`
          padding: 10px 20px;
          margin-bottom: 0;
          font-size: 0.8em;
        `
      : css`
          padding: 20px 32px;
          margin-bottom: 32px;
        `}

  ${props =>
    props.block &&
    css`
      display: block;
      width: 100%;
    `}

  ${MaxWidth.sm`
    padding: 12px;
  `}
`;

export { WellWrapper };
